.card {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  width: 280px;
  max-width: calc(100vw - 16px);
  padding: 10px 12px;
  border: 1px solid var(--gray-300);
  border-radius: 6px;
  background: var(--surface-elevated);
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  font-size: 12px;
  line-height: 16px;
  pointer-events: none;
}

.top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.title,
.location {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title {
  color: var(--text-primary);
  font-weight: 600;
}

.time {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.location {
  margin-top: 2px;
  color: var(--text-secondary);
  text-transform: uppercase;
}
